
import { Injectable } from '@angular/core';
import {  HttpGeneralService} from '../../shared';
import {TitleCodes} from './title';
import { CONFIG } from '../../shared/config';
let titleUrl = CONFIG.baseUrls.titles;

@Injectable()
export class TitleService {
    constructor(private httpGeneralService: HttpGeneralService
      ) {
       
    }

    addTitle(title: TitleCodes) {
        return this.httpGeneralService.add<TitleCodes>(title, titleUrl)


    }

    deleteTitle(title: TitleCodes) {
        return this.httpGeneralService.delete<number>(title.code, `${titleUrl}`)

       
    }

    getTitles(serial: number = 0) {
     return  this.httpGeneralService.getWith(`${titleUrl}/all/proc`); 
    }

    searchTitles(k?: string) {
        let keyword = k || " ";
      return   this.httpGeneralService.getWith(`${titleUrl}/search/${keyword}`);
    }

    getTitle(id: number) {
        return this.httpGeneralService.get(id, titleUrl)

       
    }
    // used to get by stored 
    getTitleCode(code: number = 0) {
        return this.httpGeneralService.get(code, titleUrl)

    }

    updateTitle(title: TitleCodes) {
        return this.httpGeneralService.update<TitleCodes>(title.code, title, titleUrl)


    }
}
